import { render, staticRenderFns } from "./PharmaciesList.vue?vue&type=template&id=0a88053c"
import script from "./PharmaciesList.vue?vue&type=script&lang=js"
export * from "./PharmaciesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports